import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import React from 'react';
import { MemberDTO, ChequeStatusDTO } from '@/types/models';
const MemberItem = ({
  data
}: {
  data: MemberDTO;
}) => {
  const texts = {
    chequeTitle: 'چک برگشتی'
  };
  const styleConfigs = {
    [ChequeStatusDTO.notBounced]: {
      color: 'approve.text',
      bgColor: 'approve.bg4',
      chequeValue: 'ندارد'
    },
    [ChequeStatusDTO.hasBounced]: {
      color: 'critical.bg',
      bgColor: 'critical.bg4',
      chequeValue: 'دارد'
    },
    [ChequeStatusDTO.hasAsGuarantee]: {
      color: 'critical.bg',
      bgColor: 'critical.bg4',
      chequeValue: 'دارد از بابت ضمانت'
    }
  };
  const {
    color,
    bgColor,
    chequeValue
  } = styleConfigs[data.chequeStatus as ChequeStatusDTO || ChequeStatusDTO.hasBounced];
  return <Box sx={{
    display: 'flex',
    flexDirection: 'column',
    bgcolor: bgColor,
    borderRadius: 'var(--corner_radius_m)',
    gap: 'var(--spacing_xs)',
    p: 'var(--spacing_m)',
    border: '1px solid ',
    borderColor: 'stroke.stroke2'
  }} data-sentry-element="Box" data-sentry-component="MemberItem" data-sentry-source-file="MemberItem.tsx">
      <Typography variant='bodyLargeMedium__Wallfund' color='text.text' data-sentry-element="Typography" data-sentry-source-file="MemberItem.tsx">
        {data.name}
      </Typography>
      <Typography variant='captionRegular__Wallfund' color='text.text' data-sentry-element="Typography" data-sentry-source-file="MemberItem.tsx">
        {data.jobTitle}
      </Typography>
      <Box sx={{
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center'
    }} data-sentry-element="Box" data-sentry-source-file="MemberItem.tsx">
        <Typography variant='captionMedium__Wallfund' color={'text.text2'} data-sentry-element="Typography" data-sentry-source-file="MemberItem.tsx">
          {texts.chequeTitle}
        </Typography>
        {data.chequeStatus === ChequeStatusDTO.notBounced && <Typography variant='bodyStrong__Wallfund' color={color}>
            {chequeValue}
          </Typography>}

        {data.chequeStatus !== ChequeStatusDTO.notBounced && <Typography variant='captionSmallMedium__Wallfund' sx={{
        display: 'flex',
        alignItems: 'center',
        bgcolor: 'critical.bg',
        color: 'onColor.text',
        width: 'fit-content',
        minHeight: '20px',
        borderRadius: 'var(--corner_radius_circular)',
        px: 'var(--spacing_xxs)'
      }}>
            {chequeValue}
          </Typography>}
      </Box>
    </Box>;
};
export default MemberItem;